module.exports = __webpack_public_path__ + "media/camera-shutter.d5fb3f65.mp3";